/**
 * Created by JackCui on 2021/12/1
 */

// 外部组件映射 basis
// TODO 上线后修改路径
import FeTable from '../../../basis/fe-table'
import FeGroupTable from '../../../basis/fe-table/group-table.js'
import FeVirtualGroupTable from '../../../basis/fe-virtual-table/group-table.js'
import ButtonGallery from '../../../basis/button-gallery/index.vue'
import ButtonGroup from '../../../basis/button-group/index.vue'
import Buttons from '../../../basis/button/index.vue'
import Skeleton from '../../../basis/skeleton/index.vue'
import SyForm from '../../../basis/fe-form/form.vue'
import SyFormItem from '../../../basis/fe-form/form-item.vue'
import SyEditShow from '../../../basis/editor/editor-show.vue'
import group from '../../../basis/group/index.vue'
import SyLink from '../../../basis/fe-link/index.vue'
import SyPopup from '../../../basis/fe-popup/index.vue'

// 功能组件
import FieldRender from './tools/field-render/index.vue'
import FastFieldRender from './tools/field-render/fast-field.vue'
import MasterRelation from './tools/master-relation/index.vue'
// 容器组件
import page from './container/page/index.vue'
import FHeader from '../../../basis/header/index.vue'
import FFooter from '../../../basis/fe-footer/index.vue'
// import FHeader from './container/header/index.vue'
import ListLayout from './container/list-layout/index.vue'
// import ButtonsContainer from './container/buttons/index.vue'
import tabs from './container/tabs/index.vue'
import tabItem from './container/tab-item/index.vue'
import filterSearch from './container/filter/index.vue'
import filterItem from './container/filter-item/index.vue'
import FSummary from './container/summary/index.vue'
import breadcrumb from './container/crumbs/index.vue'
import FormLayout from './container/form-layout/index.vue'
// 基础组件
import SyTable from './modules/table/index.vue'
import ShortText from './modules/short-text/index.vue'
import SingleChoice from './modules/single-choice/index.vue'
import Boole from './modules/boole/index.vue'
import Date from './modules/date/index.vue'
import DropDown from './modules/drop-down/index.vue'
import SyRegion from './modules/region/index.vue'
import dropDownTree from './modules/drop-down-tree/index.vue'
import Period from './modules/period/index.vue'
import DateTime from './modules/date-time/index.vue'
import MultipleChoices from './modules/multiple-choices/index.vue'
import SyAddress from './modules/address/index.vue'
import Department from './modules/department/index.vue'
import Personnel from './modules/personnel/index.vue'
import TextArea from './modules/text-area/index.vue'
import AutoNumber from './modules/auto-number/index.vue'
import Currency from './modules/currency/index.vue'
import Special from './modules/special/index.vue'
import Percentage from './modules/percentage/index.vue'
import Number from './modules/number/index.vue'
import LookupRelationship from './modules/relationship/lookup-relationship.vue'
import MasterRelationship from './modules/relationship/master-relationship.vue'
import ReadText from './basis/read-text/index.vue'
import Jump from './modules/jump/index.vue'
import SyFile from './modules/file/index.vue'
import SyImage from './modules/image/index.vue'
import Tip from './modules/tip/index.vue'
import Quote from './modules/quote/index.vue'

// 按需引入
export {
  // paas目录下
  SyRegion,
  SyFile,
  SyImage,
  Currency,
  Number,
  ReadText,
  Tip,

  // basis目录下
  SyLink,
  SyPopup,
  ButtonGallery,
  ButtonGroup,
  Buttons,
  SyForm,
  SyFormItem
}

export default {
  MasterRelation,
  FieldRender,
  FastFieldRender,
  ButtonGroup,
  ButtonGallery,
  Buttons,
  Skeleton,
  // ButtonsContainer,
  FeVirtualGroupTable,
  FeGroupTable,
  FeTable,
  FHeader,
  FFooter,
  page,
  group,
  ListLayout,
  tabs,
  breadcrumb,
  SyForm,
  SyFormItem,
  SyEditShow,
  filterSearch,
  filterItem,
  SingleChoice,
  Boole,
  Date,
  DropDown,
  SyRegion,
  dropDownTree,
  Period,
  DateTime,
  MultipleChoices,
  SyTable,
  ShortText,
  tabItem,
  SyAddress,
  Department,
  Personnel,
  TextArea,
  AutoNumber,
  Currency,
  FSummary,
  Special,
  Percentage,
  Number,
  Quote,
  LookupRelationship,
  MasterRelationship,
  ReadText,
  // SyImporTem,
  Jump,
  SyFile,
  Tip,
  File,
  SyImage,
  FormLayout,
  SyPopup,
  SyLink
}
